import NativeCallbacks from "./NativeCallback"
import Constant from "./Constant";
import AddressManager from "./AddressManager";
import UIManager from "./UIManager";
import { Global } from "./Global";
import SDKManager from "./SDKManager";
const i18n = require('LanguageData');

class Utils {
    // 重启游戏
    restartGame () {
        // 延迟是为了可能可以解决这个版本cocos重启可能闪退的问题？？
        setTimeout(function () {
            cc.audioEngine.stopAll()
            cc.game.restart()
        }.bind(this), 100)
    }

    // 显示游戏节点
    showGameNode () {
        let gameNode = cc.find("Canvas/gameNode")
        gameNode && (gameNode.active = true)
    }

    // 隐藏游戏节点
    hideGameNode () {
        let gameNode = cc.find("Canvas/gameNode")
        gameNode && (gameNode.active = false)
    }

    //显示横条
    actionShowContent(content){
        let widget = content.getComponent(cc.Widget)
        widget && widget.updateAlignment();
        for (let i = 0; i < content.children.length; i++) {
            const node = content.children[i];
            if (node.getNumberOfRunningActions() > 0) return;
        }
        for (let i = 0; i < content.children.length; i++) {
            const node = content.children[i];
            let oldPos = node.position;
            let width = node.parent.parent.width;
            node.width = width;
            node.position = cc.v2(node.x - 400, node.y);
            node.opacity = 0;
            node.runAction(
                cc.sequence(
                    cc.delayTime(i * 0.1),
                    cc.spawn(
                        cc.moveTo(0.2, oldPos).easing(cc.easeSineOut()),
                        cc.fadeIn(0.2).easing(cc.easeSineOut())
                    )

                )
            )
        }
    }

    /**
     * 版本对比
     * @param versionA 
     * @param versionB 
     * @example Utils.versionCompare("1.0.0.0", "1.0.0.1")
     */
    versionCompare (versionA, versionB) {
        cc.log("====version A is " + versionA + ', ====version B is ' + versionB)
        var vA = versionA.split('.')
        var vB = versionB.split('.')
        
        for (var i = 0; i < vA.length; ++i) {
            var a = parseInt(vA[i])
            var b = parseInt(vB[i] || 0)
            if (a === b) {
                continue
            }
            else {
                return a - b
            }
        }
        
        if (vB.length > vA.length) {
            return -1
        }
        else {
            return 0
        }
    }

    /**
     * 截屏
     * @param node 需要截图的节点
     */
    captureScreen (node: cc.Node): cc.RenderTexture {
        let nodeCamera = new cc.Node()

        nodeCamera.setContentSize(node.getContentSize())
        nodeCamera.parent = node

        let camera = nodeCamera.addComponent(cc.Camera)
        // 新建一个 RenderTexture，并且设置 camera 的 targetTexture 为新建的 RenderTexture，这样 camera 的内容将会渲染到新建的 RenderTexture 中。
        let texture = new cc.RenderTexture()
        // 如果截图内容中不包含 Mask 组件，可以不用传递第三个参数
        texture.initWithSize(nodeCamera.width, nodeCamera.height)
        // 设置你想要的截图内容的 cullingMask
        camera.cullingMask = 0xffffffff
        camera.targetTexture = texture
        camera.alignWithScreen = false

        // 不能改变摄像机大小，所以只能调整orthoSize
        let ratio = (nodeCamera.width / nodeCamera.height) / (cc.winSize.width / cc.winSize.height)

        if (ratio < 1) {
            camera.orthoSize = nodeCamera.height / 2
        }else {
            camera.orthoSize = nodeCamera.height / 2 * ratio
        }

        // 截图会颠倒，故处理一下
        nodeCamera.angle += 180
        node.scaleX *= -1

        // 渲染一次摄像机，即更新一次内容到 RenderTexture 中
        camera.render(node)
        nodeCamera.destroy()

        // 还原
        node.scaleX *= -1

        return texture
    }

    /**
     * 保存节点的截图到本地 （仅支持原生平台）
     * @param node 节点
     * @param name 图片名
     * @example saveNodeImage(cc.find("Canvas"), "1.png")
     */
    saveNodeImage (node: cc.Node, name: string) {
        if (!cc.sys.isNative) {
            cc.log("该方法只支持原生平台")
            return
        }

        let renderTexture = this.captureScreen(node)

        if (renderTexture) {
            jsb.saveImageData(renderTexture.readPixels(), node.width, node.height, jsb.fileUtils.getWritablePath() + name)
        }
    }

    /**
     * 保存节点的截图到相册 （仅支持原生平台）
     * @param node 节点
     * @param name 图片名
     * @param callback 回调函数
     * @example saveNodeImageToAlbum(cc.find("Canvas"), "1.png")
     */
    saveNodeImageToAlbum (node: cc.Node, name: string, callback?: Function) {
        if (!cc.sys.isNative) {
            cc.log("该方法只支持原生平台")
            return
        }

        this.saveNodeImage(node, name)
        let filePath = jsb.fileUtils.getWritablePath() + name
        this.saveImageToAlbum(filePath, name, callback)
    }

    /**
     * 保存网络文件到本地 （仅支持原生平台）
     * @param url 文件地址
     * @param path 文件路径
     * @param cbFinish 完成回调函数
     * @param cbProgress 进度回调函数
     * @param cbFail 失败回调函数
     * @example saveUrlFile("http://www.baidu.com", "image/1.png")
     */
    saveUrlFile (url: string, path: string, cbFinish?, cbProgress?, cbFail?) {
        if (!cc.sys.isNative) {
            cc.log("该方法只支持原生平台")
            return
        }

        let fullPath = jsb.fileUtils.isAbsolutePath(path) ? path : jsb.fileUtils.getWritablePath() + path
        var downloader = new jsb.Downloader()

        downloader.setOnFileTaskSuccess(function(task){
            cbFinish && cbFinish(fullPath)
        })

        downloader.setOnTaskProgress(function(task, bytesReceived, totalBytesReceived, totalBytesExpected){
            cbProgress && cbProgress(totalBytesReceived / totalBytesExpected)
        })

        downloader.setOnTaskError(function(task, errorCode, errorCodeInternal, errorStr){        
            cc.log("下载文件失败", errorCode, errorCodeInternal, errorStr, url)
            cbFail && cbFail()
        })

        downloader.createDownloadFileTask(url, fullPath, "")
    }

    /**
     * 保存网络文件到本地 （使用上面的saveUrlFile方法下载缓存图片，偶尔会出现图片加载失败的问题。故又换了种方式新写了个下载函数）
     * @param url 文件地址
     * @param path 文件路径
     * @param cbFinish 完成回调函数
     * @param cbFail 失败回调函数
     */
    saveUrlFile2 (url: string, path: string, cbFinish?, cbFail?) {
        if (!cc.sys.isNative) {
            cc.log("该方法只支持原生平台")
            return
        }

        let xhr = new XMLHttpRequest()
    
        xhr.onreadystatechange = function () {
            if(xhr.readyState === 4 && xhr.status === 200){
                if(xhr.response){
                    let u8a = new Uint8Array(xhr.response)
                    // 安卓某些情况可能下载的大小为0（比如主动断开网络的情况），此时再去加载图片的话，就不会有回调，导致图片加载不出来。所以这里判断一下
                    if (u8a.length > 0) {
                        let fullPath = jsb.fileUtils.isAbsolutePath(path) ? path : jsb.fileUtils.getWritablePath() + path
                        jsb.fileUtils.writeDataToFile(u8a, fullPath)
                        cbFinish && cbFinish(fullPath)
                        return
                    }
                }
            }
            cbFail && cbFail()
        }

        xhr.ontimeout = function (e) {
            cbFail && cbFail()
        }

        xhr.onerror = function () {
            cbFail && cbFail()
        }

        xhr.responseType = 'arraybuffer'
        xhr.timeout = 60000
        xhr.open("GET", url, true)
        xhr.send()
    }

    /**
     * 保存网络图片到相册 （仅支持原生平台）
     * @param imgUrl 图片地址
     * @param name 图片名称
     * @param callback 回调函数
     */
    saveUrlImageToAlbum (imgUrl: string, name: string, callback?: Function) {
        if (!cc.sys.isNative) {
            cc.log("该方法只支持原生平台")
            return
        }

        this.saveUrlFile(imgUrl, name, function () {
            let filePath = jsb.fileUtils.getWritablePath() + name
            this.saveImageToAlbum(filePath, name, callback)
        }.bind(this))
    }
    
    /**
     * 保存图片到相册
     * @param imagePath 图片路径
     * @param name  图片名称
     * @param callback 回调函数
     */
    saveImageToAlbum (imagePath: string, name: string, callback?: Function) {
        NativeCallbacks.saveImageToAlbumCallback = callback

        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("NativeUtils", "saveImageToAlbum:", imagePath);
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/NativeUtils", "saveImageToAlbum", "(Ljava/lang/String;Ljava/lang/String;)V", imagePath, name);
        }else {
            NativeCallbacks.saveImageToAlbumCallback = null
            cc.log("该方法只支持原生平台")
        }
    }

    /**
     * 复制文本
     * @param text 文本内容
     */
    copyText (text: string) {
        if (cc.sys.isNative) {
            jsb.copyTextToClipboard(text)
        }else {

        }
    }

    /**
     * 获取设备id
     */
    getDeviceId (): string {
        if (cc.sys.os === cc.sys.OS_IOS) {
            return jsb.reflection.callStaticMethod("NativeUtils", "getDeviceId");
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            return jsb.reflection.callStaticMethod("org/cocos2dx/javascript/NativeUtils", "getDeviceId", "()Ljava/lang/String;");
        }else {
            return "unknownzdfhfsdrgdtrytr"
        }
    }

    /**
     * 从相册选照片
     * @param callback 回调函数
     * @example
     *  Utils.pickImageFromAlbum("video", function (path) {
            sprite.spriteFrame = new cc.SpriteFrame(path)
        }.bind(this))
     */
    pickImageFromAlbum (type: string, callback: Function) {
        NativeCallbacks.pickImageFromAlbumCallback = callback

        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("NativeUtils", "pickImageFromAlbum:", type);
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/NativeUtils", "pickImageFromAlbum", "(Ljava/lang/String;)V", type);
        }else {
            NativeCallbacks.pickImageFromAlbumCallback = null
            cc.log("该方法只支持原生平台")
        }
    }
    
    /**
     * 
     * @param len 字符串长度
     */
    randomString(len?) {
        len = len || 32

        let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
        let maxPos = chars.length
        let str = ''

        for (let i = 0; i < len; i++) {
            str += chars.charAt(Math.floor(Math.random() * maxPos))
        }

        return str
    }
    
    /**
     * string转Uint8Array
     * @param str 
     */
    string2Uint8Array(str: string){
        let arr = []
        let length = str.length

        for (let i = 0; i < length; i++) {
            arr.push(str.charCodeAt(i))
        }

        return new Uint8Array(arr)
    }
    
    /**
     * Uint8Array转string
     * @param fileData 
     */
    uint8Array2String(fileData: Uint8Array){
        let str = ""
        let length = fileData.length

        for (var i = 0; i < length; i++) {
            str += String.fromCharCode(fileData[i]);
        }
    
        return str
    }

    /**
     * 设置屏幕方向
     * @param value 横屏H，竖屏V，A自动
     */
    setOrientation (value: string) {
        value = value.toUpperCase()
        let frameSize = cc.view.getFrameSize()
        
        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("AppController", "setOrientation:", value)
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "setOrientation", "(Ljava/lang/String;)V", value);
        }else if (cc.sys.isBrowser) {
            if (value === "V") {
                cc.view.setOrientation(cc.macro.ORIENTATION_PORTRAIT)
                frameSize.width > frameSize.height && cc.view.setFrameSize(frameSize.height, frameSize.width)
            }else if (value === "H") {
                cc.view.setOrientation(cc.macro.ORIENTATION_LANDSCAPE)
                frameSize.width < frameSize.height && cc.view.setFrameSize(frameSize.height, frameSize.width)
            }else {
                cc.view.setOrientation(cc.macro.ORIENTATION_AUTO)
            }
        }

        NativeCallbacks.onOrientationChanged(value)
    }

    /**
     * 动态申请权限
     * @param permissions 权限数组
     * @example
     * let permissions = [
            "android.permission.READ_EXTERNAL_STORAGE",
            "android.permission.WRITE_EXTERNAL_STORAGE",
            "android.permission.CAMERA"
        ]
        Utils.requestPermissions(permissions)
     */
    requestPermissions (permissions: Array<string>) {
        if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/NativeUtils", "requestPermissions", "(Ljava/lang/String;)V", permissions.toString());
        }
    }

    /**
     * 获取包名
     */
    getPackageName (): string {
        if (cc.sys.os === cc.sys.OS_IOS) {
            return jsb.reflection.callStaticMethod("NativeUtils", "getPackageName")
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            return jsb.reflection.callStaticMethod("org/cocos2dx/javascript/NativeUtils", "getPackageName", "()Ljava/lang/String;");
        }else {
            cc.log("该方法只支持原生平台")
            return ""
        }
    }

    /**
     * 获取原生平台版本号
     */
    getNativeVersion (): string {
        if (cc.sys.os === cc.sys.OS_IOS) {
            return jsb.reflection.callStaticMethod("NativeUtils", "getVersionString")
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            return jsb.reflection.callStaticMethod("org/cocos2dx/javascript/NativeUtils", "getVersionString", "()Ljava/lang/String;");
        }else {
            cc.log("该方法只支持原生平台")
            return "0.0.0"
        }
    }
    //设置游戏盾
    setShieldAddress(){
        let access_key = Constant.GameShieldAccessKey;
        let token = cc.sys.localStorage.getItem('UserID') || "Default";
        let groupName = Constant.GameShieldGroupName;
        let ddomain = Constant.GameShieldDomain;
        let dport = Constant.GameShieldPort;

        if (cc.sys.os === cc.sys.OS_IOS) {
            cc.log("======进入苹果游戏盾");
            let port = jsb.reflection.callStaticMethod("NativeUtils", "getProxyTcp:addtoken:addgroupName:addddomain:adddport:",access_key,token,groupName,ddomain,dport);
            if (port){
                let serverAddress = "http://127.0.0.1:" + port;
                AddressManager.setAliAddress(serverAddress);
            }
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            cc.log("====进入安卓游戏盾");
            let port = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/NativeUtils", "getProxyTcpByDomain", "(Ljava/lang/String;Ljava/lang/String;Ljava/lang/String;Ljava/lang/String;Ljava/lang/String;)Ljava/lang/String;",access_key,token,groupName,ddomain,dport);
            if (port){
                let serverAddress = "http://127.0.0.1:" + port;
                AddressManager.setAliAddress(serverAddress);
            }
        }else if (cc.sys.isBrowser) {
            cc.log("==网页端没有游戏盾");
        }
    }

        //生成游戏盾地址
        getShieldAddress(
            access_key = Constant.GameShieldAccessKey,
            groupName = Constant.GameShieldGroupName,
            ddomain = Constant.GameShieldDomain,
            dport = Constant.GameShieldPort,
            token = cc.sys.localStorage.getItem('UserID') || "Default") {
            if (cc.sys.os === cc.sys.OS_IOS) {
                cc.log("======开始生成苹果游戏盾");
                let port = jsb.reflection.callStaticMethod("NativeUtils", "getProxyTcp:addtoken:addgroupName:addddomain:adddport:", access_key, token, groupName, ddomain, dport);
                if (port) {
                    let serverAddress = "http://127.0.0.1:" + port;
                    return serverAddress;
                }
            } else if (cc.sys.os === cc.sys.OS_ANDROID) {
                cc.log("====开始生成安卓游戏盾");
                let port = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/NativeUtils", "getProxyTcpByDomain", "(Ljava/lang/String;Ljava/lang/String;Ljava/lang/String;Ljava/lang/String;Ljava/lang/String;)Ljava/lang/String;", access_key, token, groupName, ddomain, dport);
                if (port) {
                    let serverAddress = "http://127.0.0.1:" + port;
                    return serverAddress;
                }
            } else if (cc.sys.isBrowser) {
                cc.log("==网页端不生成游戏盾");
            }
        }
    
        //重设游戏服务器列表
        flushServerList(list){
            AddressManager.flushServerList(list)
        }
    //游戏类型 转为层级
    gameTypeToLayer(gameType){
        let str = "";
        switch (gameType) {
            case Global.GameType.Chess://棋牌
                str = "chessandcard";
                break;
            case Global.GameType.Lottery://彩票
                str = "lottery";
                break;
            case Global.GameType.Electronic://电子
                str = "electronic";
                break;
            case Global.GameType.Live://真人
                str = "livevideo";
                break;
            case Global.GameType.Sport://体育
                str = "sports";
                break;
            case Global.GameType.ESport://电竞
                str = "esports";
                break;
            case Global.GameType.Fish://捕鱼
                str = "fish";
                break;

        }
        return str;
    }

    getImage(url):Promise<any>{
        UIManager.showLoadingUI()
        return new Promise<any>(resolve => {
            cc.loader.load(url, function (err, texture) {
                if (!err) {
                    UIManager.hideLoadingUI()
                    resolve(texture);
                }else {
                    UIManager.hideLoadingUI()
                    resolve(null);
                }
            }.bind(this))
        })

    }

    // 获取最小值到最大值之前的整数随机数
    getRandomNum(Min:number, Max:number) {
        var Range = Max - Min;
        var Rand = Math.random();
        return(Min + Math.round(Rand * Range));
    }

    /**
     * 调用系统分享方法
     * @param title 标题
     * @param imagePath 图片全路径
     * @param url 网址
     */
    share (title: string, imagePath: string, url: string) {
        if (cc.sys.isMobile) {
            let ret
            if (cc.sys.os === cc.sys.OS_IOS) {
                ret = jsb.reflection.callStaticMethod("NativeUtils","share:imagePath:url:", title, imagePath, url)
            }else if (cc.sys.os === cc.sys.OS_ANDROID) {
                ret = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/NativeUtils", "share", "(Ljava/lang/String;Ljava/lang/String;Ljava/lang/String;)Z", title, imagePath, url)
            }
            if (ret === undefined) {
                UIManager.showTipUI(i18n.t("download_new_version"))
            }
        }else {
            cc.log("该方法只支持原生平台")
        }
    }

    // 打开客服链接
    openOnlineCustomerUrl () {
        UIManager.showLoadingUI()
        let xhr = new XMLHttpRequest()
        xhr.responseType = 'json'

        xhr.onload = function () {
            UIManager.hideLoadingUI()
            if (xhr.status === 200){
                let list = xhr.response.data || []
                for (let i = 0; i < list.length; i++) {
                    const element = list[i];
                    if (element.type === "Online" && element.list.length > 0) {
                        cc.sys.openURL(element.list[0].content)
                        break
                    }
                }
            }
        }.bind(this)

        xhr.onerror = function () {
            UIManager.hideLoadingUI()
        }
        
        xhr.ontimeout = function (e) {
            UIManager.hideLoadingUI()
        }

        xhr.open("POST", AddressManager.getServerAdress() + "/api/customService/list", true)
        xhr.send()
    }

    /*
     * param str 要截取的字符串
     * param L 要截取的字节长度，注意是字节不是字符，一个汉字两个字节
     * return 截取后的字符串
     */
    cutStr(str,L){
        var result = '',
            strlen = str.length, // 字符串长度
            chrlen = str.replace(/[^\x00-\xff]/g,'**').length; // 字节长度

        if(chrlen<=L){return str;}

        for(var i=0,j=0;i<strlen;i++){
            var chr = str.charAt(i);
            if(/[\x00-\xff]/.test(chr)){
                j++; // ascii码为0-255，一个字符就是一个字节的长度
            }else{
                j+=2; // ascii码为0-255以外，一个字符就是两个字节的长度
            }
            if(j<=L){ // 当加上当前字符以后，如果总字节长度小于等于L，则将当前字符真实的+在result后
                result += chr;
            }else{ // 反之则说明result已经是不拆分字符的情况下最接近L的值了，直接返回
                return result;
            }
        }
    }

    strlen(str) {
        var len = 0;
        for (var i = 0; i < str.length; i++) {
            var c = str.charCodeAt(i);
            //单字节加1
            if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
                len++;
            }
            else {
                len += 2;
            }
        }
        return len;
    }

    handleNameLen(playerName, len) {
        var new_playerName = "";
        let j = 0
        if (this.strlen(playerName) > len) {
            for (let i = 0; i < len; i) {
                let c = playerName.charCodeAt(j);
                if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
                    i++;
                }
                else {
                    i += 2;
                }
                new_playerName += playerName[j++]
                if (playerName.length <= j) {
                    break
                }
            }
            new_playerName += "..."
        }
        else {
            new_playerName = playerName;
        }
        return new_playerName;
    }


    getInstallParms(node):Promise<any>{
        let _channelCode = null;
        let _bindData = null;
        console.log("====进入getInstallParms  ");
        return new Promise<any>(resolve => {
            if (!cc.sys.isMobile) {
                resolve([_channelCode,_bindData])
                return
            }
            if (cc.sys.os === cc.sys.OS_IOS) {
                let nativeChannel = jsb.reflection.callStaticMethod("AppController", "nativeChannel");
                if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                    _channelCode = nativeChannel;
                }
            } else if (cc.sys.os === cc.sys.OS_ANDROID) {
                let nativeChannel = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "nativeChannel", "()Ljava/lang/String;");
                if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                    _channelCode = nativeChannel;
                }
            }
            if (Constant.InstallSDK === 0) {
                SDKManager.getInstallParms(function (data) {
                    cc.log("x === 0 parms:" + (data ? JSON.stringify(data) : ""))
                    // 从openinstall 获取了一次了
                    _channelCode = (data && data["channelCode"]) ? data["channelCode"] : "";
                    if (cc.sys.os === cc.sys.OS_IOS) {
                        let nativeChannel = jsb.reflection.callStaticMethod("AppController", "nativeChannel");
                        if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                            _channelCode = nativeChannel;
                        }
                    } else if (cc.sys.os === cc.sys.OS_ANDROID) {
                        let nativeChannel = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "nativeChannel", "()Ljava/lang/String;");
                        if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                            _channelCode = nativeChannel;
                        }
                    }
                    _bindData = (data && data["bindData"]) ? JSON.parse(data["bindData"]) : {}
                    Global.installParms[0] = _channelCode;
                    Global.installParms[1] = _bindData;

                    resolve([_channelCode,_bindData])
                }.bind(this))
            }else if (Constant.InstallSDK === 1) {
                SDKManager.getShareInstallParm(function (data) {
                    cc.log("InstallSDK === 1 parms:" + (data ? JSON.stringify(data) : ""))
                    _channelCode = (data && data["channelCode"]) ? data["channelCode"] : "";
                    if (cc.sys.os === cc.sys.OS_IOS) {
                        let nativeChannel = jsb.reflection.callStaticMethod("AppController", "nativeChannel");
                        if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                            _channelCode = nativeChannel;
                        }
                    } else if (cc.sys.os === cc.sys.OS_ANDROID) {
                        let nativeChannel = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "nativeChannel", "()Ljava/lang/String;");
                        if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                            _channelCode = nativeChannel;
                        }
                    }
                    _bindData = {"code": (data && data["code"]) ? data["code"] : ""}
                    Global.installParms[0] = _channelCode;
                    Global.installParms[1] = _bindData;
                    resolve([_channelCode,_bindData])
                }.bind(this))
            }else if (Constant.InstallSDK === 2) {
                SDKManager.getShareTraceParm(function (data) {
                    cc.log("InstallSDK === 2 parms:" + (data ? JSON.stringify(data) : ""))
                    _channelCode = (data && data["channelCode"]) ? data["channelCode"] : "";
                    if (cc.sys.os === cc.sys.OS_IOS) {
                        let nativeChannel = jsb.reflection.callStaticMethod("AppController", "nativeChannel");
                        if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                            _channelCode = nativeChannel;
                        }
                    } else if (cc.sys.os === cc.sys.OS_ANDROID) {
                        let nativeChannel = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "nativeChannel", "()Ljava/lang/String;");
                        if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                            _channelCode = nativeChannel;
                        }
                    }
                    _bindData = {"code": (data && data["code"]) ? data["code"] : ""}
                    Global.installParms[0] = _channelCode;
                    Global.installParms[1] = _bindData;
                    resolve([_channelCode,_bindData])
                }.bind(this))
            }
            node.scheduleOnce(function () {
                resolve([_channelCode,_bindData])
            },10)

        })
    }


    //世界转本地坐标
    world_local_POS = function (node, pos) {
        return node.convertToNodeSpaceAR(pos)
    }

    //本地转世界坐标
    local_world__POS = function (node,pos = cc.v2(0,0)) {
        return node.convertToWorldSpaceAR(pos);
    }

    /**
     * 重复点击按钮延迟
     * event 点击事件 or node
     * duration 点击对象暂停响应秒数
    **/
    disable_btn_sec = function (event, duration) {
        if (event instanceof cc.Event.EventTouch) {
            let node = event.target
            node.getComponent(cc.Button).interactable = false
            node.runAction(
                cc.sequence(
                    cc.delayTime(duration),
                    cc.callFunc(function () {
                        node.getComponent(cc.Button).interactable = true
                    })
                )
            )
        }
    }


    /**
     * 使用base64Data加载一张图片
     * @param sprite 精灵:cc.Sprite
     * @param base64Data imageData
     */
    base64ImageLoad(sprite:cc.Sprite, base64Data: string) {
        let imageObj = new Image();
        imageObj.src = base64Data;
        let textureObj = new cc.Texture2D();
        textureObj.initWithElement(imageObj);
        textureObj.handleLoadedTexture();
        if (sprite.node.isValid) {
            sprite.spriteFrame = new cc.SpriteFrame(textureObj)
        }
    }

}

export default new Utils()